import React, { useState } from "react";
import Youtube from "@material-ui/icons/YouTube";
import { Container, Modal } from "react-bootstrap";
import CloudSocialLogo from "../../../../asset/image/CloudSocialLogo.svg";
import { video } from "../../../../asset/json/videoData";
import "./video.scss";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
// import CsLogo from "../../../../asset/image/CSLogo.svg";
import { Zoom } from "react-reveal";
import { Helmet } from "react-helmet";

const useStyles = makeStyles({
  root: {
    // maxWidth: 345,
    width: 260,
    borderRadius: 10,
    marginBottom: "10%",
    fontFamily: "Montserrat",
  },
  media: {
    height: 160,
  },
  font: {
    fontFamily: "Montserrat",
  },
});
const Video = () => {
  const classes = useStyles();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [dataa, setdataa] = useState(video.CloudInfluence);
  const [active, setactive] = useState("CloudInfluence");
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Resource Video page" />
        <meta
          name="description"
          content="CloudSocial provides all the video resources which guide you to succeed in the CloudSocial media marketing platform. Check out our learning materials."
        />
        <title>Video - Social Media Resources by CloudSocial</title>
        <link rel="canonical" href="https://cloudsocial.io/resources/video" />
      </Helmet>
      <Container>
        <div className="video-card-container">
          <Zoom cascade>
            {dataa.map((data) => {
              return (
                <div>
                  <Modal
                    size="xl"
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    centered
                  >
                    <Modal.Header className="modelHeader" closeButton>
                      <img
                        src={CloudSocialLogo}
                        alt="CloudSocial"
                        className="modalLogo"
                      />
                    </Modal.Header>
                    <Modal.Body className="model-body">
                      <div
                        className="video"
                        style={{
                          position: "relative",
                          paddingBottom: "56.25%",
                          paddingTop: "25",
                          height: "0",
                          wrapAround: true,
                          cursor: "pointer",
                          freeScroll: true,
                        }}
                      >
                        <iframe
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                          src={active}
                          frameBorder="0"
                          // className="videoCardYoutube"
                          title="CloudSocial"
                        />
                      </div>
                    </Modal.Body>
                  </Modal>
                  <Card
                    className={classes.root}
                    onClick={() => {
                      handleShow();
                      setactive(data.url);
                    }}
                  >
                    <CardActionArea>
                      <CardMedia
                        className={classes.media}
                        image={data.image}
                        title="Contemplative Reptile"
                        onClick={() => {
                          handleShow();
                          setactive(data.url);
                        }}
                      />
                      <CardContent>
                        <Typography gutterBottom>
                          <div className="card-videoData">
                            <div className={classes.font}>{data.title}</div>
                            <div>
                              <Youtube className="logo-youtube" />
                            </div>
                          </div>
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </div>
              );
            })}
          </Zoom>
        </div>
      </Container>
    </div>
  );
};

export default Video;
